import React from 'react'
import T from 'prop-types'
import { styled } from '@mui/system'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const listTypeToTabIndex = {
  grouping: 0,
  costing: 1,
  parameters: 2,
}

const CustomTab = ({ to, ...props }) => {
  return (
    <Link to={to}>
      <Tab component="p" {...props} />
    </Link>
  )
}

const RulesHeader = ({ listType }) => {
  const { t } = useTranslation()
  const location = useLocation()

  return (
    <Container>
      <div style={{ display: 'flex' }}>
        <Tabs value={listTypeToTabIndex[listType]}>
          <CustomTab
            to={`${location.pathname}?type=grouping`}
            label={t('rules.grouping.title')}
          />
          <CustomTab
            to={`${location.pathname}?type=costing`}
            label={t('rules.costing.title')}
          />
          <CustomTab
            to={`${location.pathname}?type=parameters`}
            label={t('rules.parameters.title')}
          />
        </Tabs>
      </div>
    </Container>
  )
}

RulesHeader.propTypes = {
  listType: T.oneOf(['grouping', 'costing', 'parameters']).isRequired,
}

export default RulesHeader

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}))
